import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { forumCategories } from '../data/forumData';

import { useTranslation } from 'react-i18next';
const NewTopicForm = ({ onCancel }) => {
    const { t } = useTranslation();
const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    categoryId: forumCategories[0].id,
    content: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.content.trim()) {
      alert('Please fill in all required fields.');
      return;
    }

    // In a real app, this would be an API call
    console.log('New topic submitted:', formData);
    alert('Topic created successfully! (Mock implementation)');
    navigate('/community');
  };

  return (
    <div className="bg-zinc-800 p-6 rounded shadow-sm">
      <h2 className="text-2xl font-semibold mb-6 text-amber-500">{t('new_topic_form.create_new_topic')}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Topic Title *</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            className="w-full p-2 rounded bg-zinc-900 text-white border border-zinc-700 focus:outline-none focus:border-amber-500"
            placeholder={t('new_topic_form.what_is_your_question_or_idea')}
            required
          />
        </div>
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Category *</label>
          <select
            value={formData.categoryId}
            onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
            className="w-full p-2 rounded bg-zinc-900 text-white border border-zinc-700 focus:outline-none focus:border-amber-500"
            required
          >
            {forumCategories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-zinc-400 text-sm mb-1">Content (Markdown supported) *</label>
          <textarea
            rows="8"
            value={formData.content}
            onChange={(e) => setFormData({ ...formData, content: e.target.value })}
            className="w-full p-2 rounded bg-zinc-900 text-white border border-zinc-700 focus:outline-none focus:border-amber-500"
            placeholder={t('new_topic_form.describe_your_topic_in_detail')}
            required
          ></textarea>
        </div>
        <div className="flex justify-end space-x-4">
          <button type="button" onClick={onCancel} className="px-4 py-2 rounded text-zinc-300 hover:text-white transition-colors duration-200">{t('new_topic_form.cancel')}</button>
          <button type="submit" className="bg-amber-500 text-black px-6 py-2 rounded hover:bg-amber-400 transition-colors duration-200">{t('new_topic_form.post_topic')}</button>
        </div>
      </form>
    </div>
  );
};

export default NewTopicForm;
